
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { StateType } from "./productionSubject";
import { getProductionInfo } from "../../../../api/production";
import { ImagePreview } from "vant";

const states = {
  screenHeight: 0,
  dataInfo: {},
  id:''
};

export default defineComponent({
  props:["dataId"],
  setup(prop) {
    const state = reactive<StateType>(states);
    const { getPrimaryData } = useDatas(state);
    onMounted(() => {
      state.id = prop.dataId
      getPrimaryData();
    });
    return {
      ...toRefs(state),
      ...useEvent(state)
    };
  },
});
const useDatas = (state: StateType) => {
  const getPrimaryData = async () => {
    const result: any = await getProductionInfo({ traceSourceId: state.id });
    if (result.data.code == 0) {
      state.dataInfo = result.data.data;
    }
  };

  return {
    getPrimaryData,
  };
};
const useEvent = (state: StateType) => {
  const getImgUrl = (data:any) => {
    if(data.length == 0){
      return ""
    } 
    
    return state.dataInfo.imgs[0].url
  }
  const onPreiviewImg = (data:any) => {
    if(data.length == 0){
      return
    }
      ImagePreview([data[0].url])
  }
  const onCall = () => {
    const a = document.createElement("a");
    a.href = "tel:" + state.dataInfo.phone;
    let body: any = document.getElementsByTagName("body")[0];
    body.appendChild(a);
    a.click();
    body.remove;
  };
  return {
    onCall,
    getImgUrl,
    onPreiviewImg
  };
};
